/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import React from 'react'
import autoBind from 'react-autobind'
import moment from 'moment'
import { injectIntl } from 'react-intl'
import { FontIcon } from 'material-ui'

import { getDateTime } from 'utils/date'
import { TextField, DatePicker, TimePicker } from 'generic/form'
import * as constants from 'constants/Prestation'

class InterpreterSearchTop extends React.Component {

  constructor(props) {
    super(props)
    autoBind(this)

    let defaultStartTime = moment().startOf('hour')
    if (defaultStartTime < moment()) {
      defaultStartTime = moment().startOf('hour').add(1, 'hours')
    }

    this.state = {
      defaultStartTime: defaultStartTime,
      defaultEndTime: undefined,
    }
  }

  componentDidUpdate(prevProps) {
    const prestation = this.props.prestation

    if (prestation &&
        prestation.ordered_start_time &&
        prestation.ordered_start_time.length === 5 &&
        prestation.ordered_start_time !== prevProps.prestation.ordered_start_time) {

      let date = moment()
      if (prestation.ordered_date && prestation.ordered_date.length === 10) {
        date = moment(prestation.ordered_date, 'YYYY-MM-DD')
      }

      const dateTime = getDateTime(date, moment(prestation.ordered_start_time, 'HH:mm'))
      this.setState({
        defaultEndTime: moment(dateTime, 'YYYY-MM-DD HH:mm').add(1, 'hours')
      })
    }
  }

  handleSetStartRef(field) {
    this.startTimePicker = field || null
  }

  handleSetEndRef(field) {
    this.endTimePicker = field || null
  }

  handleSetDateRef(field) {
    this.datePicker = field || null
  }

  handleDateFormatChange(event, value) {
    new Promise((resolve, reject) => {
      this.props.handleDateFormatChange(event.target.name, value)
      resolve()
    })
    .then(() => {
      this.props.handleShowDetails()
    })
  }

  handleDateChange(event, value) {
    new Promise((resolve, reject) => {
      this.props.handleDateChange(event.target.name, value)
      resolve()
    })
    .then(() => {
      this.props.handleShowDetails()
    })
  }

  handleTimeFormatChange(event, value) {
    new Promise((resolve, reject) => {
      this.props.handleTimeFormatChange(event.target.name, value)
      resolve()
    })
    .then(() => {
      this.props.handleShowDetails()
    })
  }

  handleTimeChange(event, value) {
    new Promise((resolve, reject) => {
      this.props.handleTimeChange(event.target.name, value)
      resolve()
    })
    .then(() => {
      this.props.handleShowDetails()
    })
  }

  render() {
    const prestation = this.props.prestation
    const meta = prestation && prestation.meta ? prestation.meta.fields : {}
    const orderedDate = prestation &&
                        prestation.ordered_date &&
                        prestation.ordered_date.length === 10
                          ? moment(prestation.ordered_date).format('DD.MM.YYYY')
                          : prestation &&
                            prestation.ordered_date
                            ? prestation.ordered_date
                            : undefined

    const orderedStartTime = prestation &&
                             prestation.ordered_start_time &&
                             prestation.ordered_start_time.length === 5
                               ? moment(prestation.ordered_start_time, 'HH:mm').format('HH:mm')
                               : prestation && prestation.ordered_start_time
                                 ? prestation.ordered_start_time
                                 : undefined

    const orderedEndTime = prestation &&
                             prestation.ordered_end_time &&
                             prestation.ordered_end_time.length === 5
                               ? moment(prestation.ordered_end_time, 'HH:mm').format('HH:mm')
                               : prestation && prestation.ordered_end_time
                                 ? prestation.ordered_end_time
                                 : undefined

    return (
      <React.Fragment>
        <div
          className='col-md-3 col-xs-12'
          style={{position: 'relative'}}
        >
          <TextField
            name='ordered_date'
            meta={meta.ordered_start_time}
            disabled={!!prestation.uid}
            value={orderedDate}
            floatingLabelText={this.props.intl.formatMessage(constants.messages.DATE_LABEL)}
            onChange={this.handleDateFormatChange}
            mask='99.99.9999'
            style={styles.fontText}
            errorText={this.props.errors ? this.props.errors.ordered_date : undefined}
            placeholderMandatory={true}
          />

          <DatePicker
            name='ordered_date'
            divStyle={{display: 'none'}}
            locale={this.props.intl.locale}
            onChange={this.handleDateChange}
            getField={this.handleSetDateRef}
          />

          {
            !prestation.uid
              ? <FontIcon
                onClick={() => this.datePicker.focus()}
                className='material-icons'
                style={{
                  margin: '20px 5px 0 0',
                  top: 20,
                  right: 0,
                  position: 'absolute',
                  cursor: 'pointer'
                }}
              >today
              </FontIcon>
              : undefined
          }
        </div>

        <div
          className='col-md-2 col-xs-12'
          style={{position: 'relative'}}
        >
          <TextField
            name='ordered_start_time'
            meta={meta.ordered_start_time}
            disabled={!!prestation.uid}
            value={orderedStartTime}
            floatingLabelText={this.props.intl.formatMessage(constants.messages.START_LABEL)}
            onChange={this.handleTimeFormatChange}
            mask='99.99'
            style={styles.fontText}
            errorText={this.props.errors ? this.props.errors.ordered_start_time : undefined}
            placeholderMandatory={true}
          />

          <TimePicker
            name='ordered_start_time'
            divStyle={{display: 'none'}}
            locale={this.props.intl.locale}
            onChange={this.handleTimeChange}
            getField={this.handleSetStartRef}
            value={this.state.defaultStartTime}
          />

          {
            !prestation.uid
              ? <FontIcon
                onClick={() => this.startTimePicker.focus()}
                className='material-icons'
                style={{
                  margin: '20px 5px 0 0',
                  top: 20,
                  right: 0,
                  position: 'absolute',
                  cursor: 'pointer'
                }}
              >schedule
              </FontIcon>
              : undefined
          }
        </div>

        <div
          className='col-md-2 col-xs-12'
          style={{position: 'relative'}}
        >
          <TextField
            name='ordered_end_time'
            meta={meta.ordered_end_time}
            disabled={!!prestation.uid}
            value={orderedEndTime}
            floatingLabelText={this.props.intl.formatMessage(constants.messages.END_LABEL)}
            onChange={this.handleTimeFormatChange}
            mask='99.99'
            style={styles.fontText}
            errorText={this.props.errors ? this.props.errors.ordered_end_time : undefined}
            placeholderMandatory={true}
          />

          <TimePicker
            name='ordered_end_time'
            divStyle={{display: 'none'}}
            locale={this.props.intl.locale}
            onChange={this.handleTimeChange}
            getField={this.handleSetEndRef}
            value={this.state.defaultEndTime}
          />

          {
            !prestation.uid
              ? <FontIcon
                onClick={() => this.endTimePicker.focus()}
                className='material-icons'
                style={{
                  margin: '20px 5px 0 0',
                  top: 20,
                  right: 0,
                  position: 'absolute',
                  cursor: 'pointer'
                }}
              >schedule
              </FontIcon>
              : undefined
          }
        </div>
      </React.Fragment>
    )
  }
}

const styles = {
  fontText: {
    fontSize: 14
  },
}

export default injectIntl(InterpreterSearchTop)



// WEBPACK FOOTER //
// ./src/components/applicant/prestation/creation/search/InterpreterSearchTop.js